import React from "react";
import ReactDOM from "react-dom/client";
import { setupIonicReact } from "@ionic/react";
import App from "./App";

// Ionic stylesheets (kritické pro správné renderování komponent)
import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

// Routera design tokeny „Noční kokpit" (tmavý soumrak default + light krém)
import "./theme/variables.css";
import "./theme/screen.css";
import "./theme/cockpit.css";
import { initTheme } from "./lib/useTheme";

initTheme(); // aplikuj uložené téma před prvním rendrem

setupIonicReact({
  mode: "md", // Material Design jako default — Android-first, na iOS pořád OK
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
